import { useConfigStore } from './useConfigStore'
import type { AdSettings } from '../../composables/feature-flags/index.types'
import { adSettingsSchema } from '../../composables/feature-flags/index.types'

// Pinia store for managing ad settings in the application using the config store boilerplate.

export const useAdSettingsStore = useConfigStore<AdSettings>({
  defaults: adSettingsSchema.parse({
    sponsoredTiles: {
      provider: 'off',
      tilesCount: 5,
    },
    dynamicSponsoredTiles: undefined,
    aboveFoldSectionAds: undefined,
    aboveFoldSectionLeaderboardAd: '',
    enableSubtleGreyAdBackground: false,
    adsDynamicFloorPricing: {
      isEnabled: false,
      flooredPlacements: [],
    },
    summaryPage: {
      siderailTopAdPlacementType: 'programmatic',
      siderailMiddleAdPlacementType: 'off',
      siderailBottomAdPlacementType: 'off',
      contentHeroAdPlacementType: 'programmatic',
      contentTopAdPlacementType: 'off',
      contentBelowImageAdPlacementType: 'off',
      contentMiddleAdPlacementType: 'programmatic',
      contentAboveButtonAdPlacementType: 'off',
      contentBelowButtonAdPlacementType: 'programmatic',
    },
  }),
  configStoreKey: 'adSettings',
  schema: (data: unknown) => adSettingsSchema.parse(data),
})
